import { render, staticRenderFns } from "./DatepickerLabel.vue?vue&type=template&id=b78db38e&"
import script from "./DatepickerLabel.vue?vue&type=script&lang=ts&"
export * from "./DatepickerLabel.vue?vue&type=script&lang=ts&"
import style0 from "./DatepickerLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports